import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { connect, useDispatch } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';

import { BackAndMultipleButtons, ContinueButton, ContinueWithBackButtons, SaveTempButton } from 'components/base/BottomStepComponent';
import {
  defaultPreviewImage,
  getPreviewLayoutImages,
} from 'components/campaign/campaignCreation/CampaignStepTwoPreviewConfig';

import { scrollToAnchor } from './CreateCampaignHandleError';
import BaseCreationStepContentByConfig from 'components/base/BaseCreationStepContentByConfig';
import { CREATE_CAMPAIGN_CONTENT_PAGE_CONFIG } from 'containers/engagement/campaignStreamline/CreateCampaignContentPageConfig';
import './CreateCampaignContentPage.scss';
import { syncCampaignContentToCouponTemplate } from 'containers/engagement/campaignStreamline/CreateCampaignCouponPageConfig';
import RequireCampaignNamePrompt from './RequireCampaignNamePrompt';
import { ActionType, APIStatus } from 'config/CustomEnums';
import PublishCampaignPrompt from 'components/campaign/campaignCreation/PublishCampaignPrompt';

const CreateCampaignContentPage = ({
  anchorKey,
  sectionKey,
  createStatus,
  formHasSubmitted,
}) => {
  const params = useParams();
  const location = useLocation();
  const dispatch = useDispatch();
  const formContext = useFormContext()
  const {
    watch,
    formState: { errors },
    getValues,
  } = formContext;

  const watchName = watch('translations.en.generalName');
  const [showRequireNamePrompt, setShowRequireNamePrompt] = useState(false);
  const [showPublishPrompt, setShowPublishPrompt] = useState(false);

  const errorLanguage = Object.keys(errors?.translations || [])?.[0];

  const campaignTypeField = 'campaignType';
  const watchCampaignType = watch(campaignTypeField);
  const watchCampaignTranslations = watch('translations');
  const jsonTypeTranslations = JSON.stringify(watchCampaignTranslations);
  const campaignType = getValues('campaignType');

  const [fieldsError, setFieldsError] = useState(Object.keys(errors || []).length);

  const defaultImage = defaultPreviewImage(watchCampaignType); // twitch TODO
  const inputWithImageConfig = getPreviewLayoutImages(watchCampaignType);

  const saveDraftAction = () => {
    dispatch({
      type: 'createCampaign/createOrUpdateCampaignV2',
      payload: {
        data: getValues(),
        actionType: ActionType.save,
        resume: location.state?.resume,
      }
    });
  };

  useEffect(() => {
    if (createStatus === APIStatus.success && formHasSubmitted) {
      setShowPublishPrompt(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [createStatus, formHasSubmitted]);

  useEffect(() => {
    setFieldsError(Object.keys(errors || []).length);
  }, [errors]);

  useEffect(() => {
    console.log("@@createCampaignContentPage", anchorKey, sectionKey);
    scrollToAnchor(anchorKey, sectionKey);
  }, [anchorKey, sectionKey]);


  const stepChangeAction = (step) => {
    setFieldsError(0);
    dispatch({
      type: 'campaignStreamline/stepChange',
      payload: { step: step },
    });
  };
  useEffect(() => {
    syncCampaignContentToCouponTemplate(formContext)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jsonTypeTranslations])

  return (
    <>
      <BaseCreationStepContentByConfig
        configuration={CREATE_CAMPAIGN_CONTENT_PAGE_CONFIG}
        hidePreview={false}
        fieldsError={fieldsError}
        errorLanguage={errorLanguage}
        inputWithImageConfig={inputWithImageConfig} // twitch TODO
        defaultImage={defaultImage}
        sectionStyle='create-campaign-streamline-step-2'
      />

      <BackAndMultipleButtons
        backAction={() => stepChangeAction(0)}
        multipleButtons={[
          ...(
            params.id
              ? []
              : [
                <SaveTempButton
                  text="Save as draft"
                  action={() => {
                    if (!watchName) {
                      setShowRequireNamePrompt(true);
                      return;
                    };
                    saveDraftAction();
                  }}
                />
              ]
          ),
          <ContinueButton
            text="Continue"
            action={() => {
              stepChangeAction(2);
            }}
          />,
        ]}
      />
      <RequireCampaignNamePrompt
        show={showRequireNamePrompt}
        onHide={() => {
          setShowRequireNamePrompt(false);
        }}
        onConfirm={() => {
          setShowRequireNamePrompt(false);
          saveDraftAction();
        }}
      />
      <PublishCampaignPrompt
        campaignId={params.id}
        campaignType={campaignType}
        actionType={ActionType.save}
        show={showPublishPrompt}
        path={'/campaigns'}
      />
    </>
  );
}

const mapStateToProps = (state) => ({
  anchorKey: state.campaignStreamline.anchorKey,
  sectionKey: state.campaignStreamline.sectionKey,
  createStatus: state.createCampaign.createStatus,
  formHasSubmitted: state.createCampaign.formHasSubmitted,
});

export default connect(mapStateToProps)(CreateCampaignContentPage);
